import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ConfirmDialog, DocumentLoader } from 'src/components';
import certificateManagementActions from 'src/redux/actions/certificateManagement.actions';
import { IdentitySelector } from 'src/redux/selectors/identity.selector';
import usePollingStatuses from 'src/helpers/hooks/usePollingStatuses';

const SignMultipleCertificates = ({ open, documentIds, onCancel, onFinish }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { workspaceId } = useSelector(IdentitySelector.selectWorkspaceDetails, undefined);
  const count = documentIds.length;
  const validStatusTag = 'valid';
  const { isLoading, progress, completedCount, trackProgress } = usePollingStatuses({
    targetStatus: validStatusTag,
    onFinish,
  });

  return (
    <ConfirmDialog
      open={open}
      variant="success"
      title={t('documentActions.signMultipleDocuments.header')}
      subtitle={t('documentActions.signMultipleDocuments.description', { count })}
      applyButtonText={t('documentActions.signMultipleDocuments.sign')}
      cancelButtonText={t('common.cancel')}
      actionAccept={() => {
        dispatch(
          certificateManagementActions.signCertificates({
            workspaceId,
            documentIds,
            callback: () => trackProgress(documentIds),
          })
        );
      }}
      actionCancel={onCancel}
      isMainContentHidden={isLoading}
      alternativeContent={
        <DocumentLoader
          title={t('documentActions.signMultipleDocuments.toast.waitForCountUpdate')}
          progress={progress}
          count={count}
          completedCount={completedCount}
        />
      }
    />
  );
};

SignMultipleCertificates.propTypes = {
  open: PropTypes.bool,
  documentIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCancel: PropTypes.func,
  onFinish: PropTypes.bool,
};

SignMultipleCertificates.defaultProps = {
  open: false,
};

export default SignMultipleCertificates;
